import React, { useEffect, useState } from 'react';
import './LoginForm.css';
import { FaUser, FaLock } from "react-icons/fa";
import { PiSolarPanelBold } from "react-icons/pi";
import GoogleSignInWindow from './googlelogin';
import { UserAuth } from '../../authContext';
import { useNavigate } from 'react-router-dom';
import { query, collection, where, getDocs } from 'firebase/firestore';
import { db } from '../../firebase'; 

const LoginForm = () => {
    const { user, googleSignIn, error, clearError } = UserAuth();
    const navigate = useNavigate();
    const [action, setAction] = useState('');

    useEffect(() => {
        const handleLoginFlow = async () => {
            if (user != null) {
                try {
                    const userResponse = await fetchUserFromFirestore(user.email);
                    navigate('/home'); 
                } catch (err) {
                    console.error('Error checking user verification:', err);
                }
            }
        };

        handleLoginFlow();
    }, [user, navigate]);

    useEffect(() => {
        if (error) {
            alert(error);
            clearError();
        }
    }, [error, clearError]);

    const fetchUserFromFirestore = async (email) => {
        const userQuery = query(collection(db, 'users'), where('email', '==', email));
        const userSnapshot = await getDocs(userQuery);
        if (!userSnapshot.empty) {
            return userSnapshot.docs[0].data();
        }
        return null;
    };

    const registerLink = () => {
        setAction(' active');
    };
    return (
        <div className={`wrapper${action}`}>
            <div className='form-box login hide-inputs'>
                <div className='loginPage'>
                    <div>
                        <img src="Logo.png" className='logo' />
                    </div>
                    <h1>Login</h1>
                   
                    <div>
                        <GoogleSignInWindow onSignIn={googleSignIn} />
                    </div>
                    <button className='sign-in-button' onClick={()=>{navigate('/');}} style={{
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                    justifyContent: 'center',
                    textAlign: 'center'
                }}>
                <p className='text a' >
                    Back
                </p>
            </button>
                </div>
            </div>
        </div>
    );
};

export default LoginForm;